export const googleAPIKey = 'AIzaSyARC-a63vxOWRRAgpjnDYOndn_2fFLYhAo'
export const clientIDGitHub = 'Iv1.62e625903dcff9c3'
export const clientSecretGitHub = 'b09b44e7500eeacaa35a63b6253a69c5cffffab6'